/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Minus = [["path", { d: "M5 12h14" }]];

export { Minus as default };
//# sourceMappingURL=minus.js.map
